export default "__VITE_ASSET__8fbc9e3f__"